(() => {
let $0da96c3a11091cbf$var$langAnimation = ()=>{
    let dsScreen = document.getElementById("ds--screen");
    if (dsScreen !== undefined) {
        let currentLang = "de";
        setInterval(()=>{
            let langElementsDe = document.querySelectorAll(".lang_de");
            let langElementsEn = document.querySelectorAll(".lang_en");
            if (currentLang === "de") {
                fadeOut(langElementsDe);
                setTimeout(()=>fadeIn(langElementsEn), 1200);
                currentLang = "en";
            } else {
                fadeOut(langElementsEn);
                setTimeout(()=>fadeIn(langElementsDe), 1000);
                currentLang = "de";
            }
        }, 10000);
    }
    function fadeIn(elements) {
        elements.forEach((element)=>{
            element.style.display = "block";
            element.style.transition = "opacity 1s ease-in-out";
            setTimeout(()=>element.style.opacity = "1", 100);
        });
    }
    function fadeOut(elements) {
        elements.forEach((element)=>{
            element.style.transition = "opacity 1s linear";
            element.style.opacity = "0";
            setTimeout(function() {
                element.style.display = "none";
            }, 1200);
        });
    }
};
document.addEventListener("DOMContentLoaded", $0da96c3a11091cbf$var$langAnimation);
document.addEventListener("DOMContentLoaded", ()=>{
    let slides = document.querySelectorAll(".swiper-wrapper .swiper-slide");
    let currentIndex = 0;
    function activateSlide(index) {
        slides.forEach((slide, i)=>{
            slide.classList.toggle("active", i === index);
        });
    }
    function nextSlide() {
        currentIndex = (currentIndex + 1) % slides.length;
        activateSlide(currentIndex);
    }
    activateSlide(currentIndex);
    setInterval(nextSlide, 15000);
});

})();
//# sourceMappingURL=scripts.js.map
